module.exports = __webpack_public_path__ + "img/position2.0f17650d.0f17650d.png";